import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
//import { Response } from '@angular/http';
import { IRegistrationService } from './iregistration.service';
import { EventRead } from '../../shared/event-read.model';
import { RegistrationUpsert } from './crud/registration-upsert.model';
import { RegistrationRead } from './crud/registration-read.model';
import { RegistrationRegister } from './registration-register.model';
import { RegistrationAttendee } from './registration-attendee.model';
import { RegistrationAttendeeItem } from './registration-attendee-item.model';
import { RegistrationAttendeeItemCustomResponse } from './registration-attendee-item-custom-response.model';
import { RegistrationItem } from './registration-item.model';
import { RegistrationItemCustomField } from './registration-item-custom-field.model';
import { RegistrationItemCustomFieldAvailableValue } from './registration-item-custom-field-avail-value.model';
import { RegistrationItemCustomFieldAvailableValueCreditType } from './registration-item-custom-field-avail-value-credit-type.model';
import { RegistrationItemSponsor } from './registration-item-sponsor.model';
import { ApiService, UtilService, PagedSearch, PagedResult, ApiCacheOptions } from '../../../shared/index';
import { EventItemService } from '../../shared/items/event-item.service';
import { EventItemSummary } from '../../shared/items/event-item-summary.model';
import { RegistrationExpectedAmount } from './registration-expected-amount.model';
import { RegistrationSearchParams } from './registration-search-params.model';
import { RegistrationSearchResult } from './registration-search-result.model';
import { RegistrationAttendeeMin } from './registration-attendee-min.model';
import { RegistrationModificationOptions } from './crud/registration-modification-options.model';
import { PromoCodeDiscountType } from '../../shared/promo-codes/promo-code-discount-type';
import { AttendeeSearchParams } from '../../attendee/shared/attendee-search-params.model';
import { AttendeeSearchResult } from '../../attendee/shared/attendee-search-result.model';
import { EventPromoCode } from '../../shared/promo-codes/event-promo-code.model';
import { RegistrationCustomRegFieldResponse } from './registration-custom-reg-field-response.model';
import { UserService } from '../../../users/shared/user.service';
import { EventItemTotal } from './registration-event-item-total.model';
import { InvoicePayment } from '../../../revenue/shared/invoice-payment/invoice-payment.model';
import { EventPaymentMethod } from '../../shared/payment-methods/event-payment-method.model';
import { RegistrationRevenue } from './registration-revenue.model';
import { RegistrationProfileBenefit } from './registration-profile-benefit.model';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { ImportRegistrationsConfigDto } from '../../import/import-registrations/import-registations-config.dto';

@Injectable()
export class RegistrationService implements IRegistrationService {
  public _apiService: ApiService;
  public _utilService: UtilService;
  public _eventItemService: EventItemService;
  public _newRegistration: RegistrationUpsert;
  public _existingRegistration: RegistrationRead;
  public _lastUpsertedRegistrationId: number;
  public _userService: UserService;
  public _userLegacyToken: string;
  public _registration: RegistrationUpsert;

  public constructor(
    apiService: ApiService,
    utilService: UtilService,
    eventItemService: EventItemService,
    userService: UserService,
    private _navigationService: NavigationService
  ) {
    this._apiService = apiService;
    this._utilService = utilService;
    this._eventItemService = eventItemService;
    this._newRegistration = new RegistrationUpsert();
    this._existingRegistration = new RegistrationRead();
    this._lastUpsertedRegistrationId = 0;
    this._userService = userService;
    this._userLegacyToken = '';
    this._registration = new RegistrationUpsert();
  }

  public upsertRegistration = (registration: RegistrationUpsert): Promise<number> => {
    if (registration.IsEdit) {
      //edit
      this._lastUpsertedRegistrationId = Number(registration.RegistrationId);

      let url: string = 'Event/Registration/' + registration.RegistrationId.toString();
      return this._apiService.put(url, registration).then((data: number) => {
        //return the registration id
        return Promise.resolve(this._lastUpsertedRegistrationId);
      });
    } else {
      //new
      let url: string = 'Event/' + registration.EventId.toString() + '/Registrations';
      return this._apiService.post(url, registration).then((data: number) => {
        //return the registration id
        this._lastUpsertedRegistrationId = data;
        return Promise.resolve(this._lastUpsertedRegistrationId);
      });
    }
  };

  public deleteRegistration = (registrationId: number, modificationOptions: RegistrationModificationOptions): Promise<void> => {
    let url: string = 'Event/Registration/' + registrationId.toString();
    let deleteRegDto = {
      RegistrationId: registrationId,
      ModificationOptions: modificationOptions,
    };
    return this._apiService.deleteData(url, deleteRegDto);
  };

  public getNewRegistration = (eventId: number): Promise<RegistrationUpsert> => {
    this._newRegistration = new RegistrationUpsert();
    this._newRegistration.EventId = eventId;
    this._newRegistration.IsEdit = false;

    return this._eventItemService.getEventItems(eventId).then((data: Array<EventItemSummary>) => {
      for (let availItem of data) {
        let registrationItem = new RegistrationItem();

        this._utilService.map(availItem, registrationItem);

        registrationItem.Descr = availItem.Descr;
        registrationItem.EventItemId = availItem.EventItemId;
        registrationItem.EventItemSignUpId = 0;
        registrationItem.ExtendedPrice = availItem.UnitPrice;
        registrationItem.Quantity = 0;
        registrationItem.IsSponsorShip = availItem.IsSponsorShip;

        registrationItem.Selected = false;

        this._newRegistration.Items.push(registrationItem);
      }
      return Promise.resolve(this._newRegistration);
    });
  };

  public getAvailableRegistrationItems = (eventId: number): Promise<Array<RegistrationItem>> => {
    return this._eventItemService.getEventItems(eventId).then((data: Array<EventItemSummary>) => {
      let regItems = new Array<RegistrationItem>();

      for (let availItem of data) {
        let registrationItem = new RegistrationItem();

        this._utilService.map(availItem, registrationItem);

        registrationItem.Descr = availItem.Descr;
        registrationItem.EventItemId = availItem.EventItemId;
        registrationItem.EventItemSignUpId = 0;
        registrationItem.ExtendedPrice = availItem.UnitPrice;
        registrationItem.Quantity = 0;
        registrationItem.IsSponsorShip = availItem.IsSponsorShip;

        registrationItem.Selected = false;

        regItems.push(registrationItem);
      }
      return Promise.resolve(regItems);
    });
  };

  public getRegistration = (registrationId: number): Promise<RegistrationUpsert> => {
    this._existingRegistration = new RegistrationRead();
    let url = 'event/registration/' + registrationId.toString();
    return this._apiService.get(url).then((data: RegistrationRead) => {
      //5 secs
      this._existingRegistration = data;

      return this.getNewRegistration(data.EventId).then((registrationToReturn: RegistrationUpsert) => {
        //5 secs
        registrationToReturn.RegistrationId = this._existingRegistration.RegistrationId;

        this._utilService.mapSafe(this._existingRegistration.Registration, registrationToReturn.Registration);

        //set existing items
        for (let regItem of registrationToReturn.Items) {
          for (let existingRegItem of this._existingRegistration.Items) {
            if (existingRegItem.EventItemId == regItem.EventItemId) {
              this._utilService.mapSafe(existingRegItem, regItem);

              if (regItem.IsSponsorShip == true) {
                this._utilService.mapSafe(existingRegItem.Sponsor, regItem.Sponsor);
              }
            }
          }
        }

        //set existing attendees
        for (let existingAttendee of this._existingRegistration.Attendees) {
          let attendee = new RegistrationAttendee();
          this._utilService.mapSafe(existingAttendee, attendee);

          for (let existingAttendeeItem of existingAttendee.Items) {
            let attendeeItem = new RegistrationAttendeeItem();
            this._utilService.mapSafe(existingAttendeeItem, attendeeItem);
            attendee.Items.push(attendeeItem);
          }
          registrationToReturn.Attendees.push(attendee);
        }

        registrationToReturn.RegistrationId = this._existingRegistration.RegistrationId;
        registrationToReturn.EventId = data.EventId;
        registrationToReturn.Registration.EventCustomRegFieldResponses = data.Registration.EventCustomRegFieldResponses;
        registrationToReturn.PromoCodes = data.PromoCodes;

        if (registrationToReturn.RegistrationId > 0) {
          registrationToReturn.IsEdit = true;
        }

        return Promise.resolve(registrationToReturn);
      });
    });
  };

  public getRegistrationHeaderMin = (registrationId: number): Promise<RegistrationRegister> => {
    if (registrationId > 0) {
      let url = 'event/registration/' + registrationId.toString() + '/HeaderMin';
      let cacheOptions = new ApiCacheOptions();
      cacheOptions.DisableCaching = true;

      return this._apiService.get(url, cacheOptions).then((data: any) => {
        let result = new RegistrationRegister();
        this._utilService.mapSafe(data, result);

        result.BenefitsPreviouslyApplied = data.BenefitsPreviouslyApplied;
        result.BenefitsPreviouslyAppliedTotal = data.BenefitsPreviouslyAppliedTotal;

        return Promise.resolve(result);
      });
    } else {
      return Promise.resolve(new RegistrationRegister());
    }
  };

  public getRegistrationItemsMin = (registrationId: number): Promise<Array<RegistrationItem>> => {
    if (registrationId > 0) {
      let url = 'event/registration/' + registrationId.toString() + '/ItemsMin';
      return this._apiService.get(url);
    } else {
      return Promise.resolve(new Array<RegistrationItem>());
    }
  };

  public getRegistrationAttendeesMin(registrationId: number): Promise<Array<RegistrationAttendee>> {
    if (registrationId > 0) {
      const options = this._apiService.getDefaultApiCacheOptionsForFrequentlyChangedData();
      options.CacheSeconds = 10;
      let url = 'event/registration/' + registrationId.toString() + '/AttendeesMin';
      return this._apiService.get(url, options);
    } else {
      return Promise.resolve(new Array<RegistrationAttendee>());
    }
  }

  public getRegistrationAmountPaid = (registrationId: number): Promise<number> => {
    if (registrationId > 0) {
      let url = 'event/registration/' + registrationId.toString() + '/AmountPaid';
      return this._apiService.get(url);
    } else {
      return Promise.resolve(0);
    }
  };

  public getRegistrationRevenue = (registrationId: number): Promise<RegistrationRevenue> => {
    if (registrationId > 0) {
      let url = 'event/registration/' + registrationId.toString() + '/RevenueDetails';
      let cacheOptions = new ApiCacheOptions();
      cacheOptions.DisableCaching = true;
      return this._apiService.get(url, cacheOptions);
    } else {
      return Promise.resolve(new RegistrationRevenue());
    }
  };

  public getRegistrationPromoCodes = (registrationId: number): Promise<Array<EventPromoCode>> => {
    if (registrationId > 0) {
      let url = 'event/registration/' + registrationId.toString() + '/PromoCodes';
      return this._apiService.get(url);
    } else {
      return Promise.resolve(new Array<EventPromoCode>());
    }
  };

  public getRegistrationCustomFieldResponses = (registrationId: number): Promise<Array<RegistrationCustomRegFieldResponse>> => {
    if (registrationId > 0) {
      let url = 'event/registration/' + registrationId.toString() + '/CustomFieldResponses';
      return this._apiService.get(url);
    } else {
      return Promise.resolve(new Array<RegistrationCustomRegFieldResponse>());
    }
  };

  public getCreateRegistrationExpectedAmount = (eventId: number, registration: RegistrationUpsert): Promise<RegistrationExpectedAmount> => {
    let url = 'event/' + eventId.toString() + '/registrations/expectedamount';
    return this._apiService.post(url, registration);
  };

  public getUpdateRegistrationExpectedAmount = (
    registrationId: number,
    registration: RegistrationUpsert
  ): Promise<RegistrationExpectedAmount> => {
    let url = 'event/registration/' + registrationId.toString() + '/expectedamount';
    return this._apiService.post(url, registration);
  };

  public searchRegistrations = (searchParams: RegistrationSearchParams): Promise<RegistrationSearchResult> => {
    let url = 'Event/' + searchParams.EventId.toString() + '/Search/Registrations';
    return this._apiService.postPaged(url, searchParams).then((data: RegistrationSearchResult) => {
      for (let reg of data.Result) {
        reg.ShowDetails = false;
        reg.LoadingDetails = false;
        reg.Selected = false;
      }

      return Promise.resolve(data);
    });
  };

  public getRegistrationAttendees = (registrationId: number): Promise<Array<RegistrationAttendeeMin>> => {
    let url = 'Event/Registration/' + registrationId.toString() + '/Attendees';
    return this._apiService.get(url);
  };

  /**
   * get attendee headers
   * @param registrationHeaderId
   */
  public getRegistrationAttendeeHeaders(registrationHeaderId: number): Promise<Array<RegistrationAttendeeMin>> {
    let url = 'Event/Registration/' + registrationHeaderId.toString() + '/AttendeeHeaders';
    return this._apiService.get(url);
  }

  public calculateTotals(registration: RegistrationUpsert) {
    let itemTotal: number = 0;
    let taxAmount: number = 0;
    let discountTotal: number = 0;

    this._registration = registration;

    //let url = "Event/" + registration.EventId.toString() + "/EventPaymentMethods";
    //return this._apiService.get(url).then((data: Array<EventPaymentMethod>) => {
    //    //need to get the selected payment method to see if there is a fee

    //});

    //let currentlyPaidAmount: number = registration.Registration.TotalAmount - registration.Registration.AdditionalPaymentAmountForEdit;

    let eventItemTotals: Array<EventItemTotal> = [];
    let usedOneTimePromoCodeIds: number[] = [];

    for (let availItem of registration.Items) {
      let singleQuantityPrice: number = 0;

      // start collecting totals
      let eventItemTotal: EventItemTotal = new EventItemTotal();

      eventItemTotal.EventItem = availItem;

      if (availItem.Quantity > 0) {
        if (
          (registration.Registration.ForceMemberPricing ||
            registration.Registration.IsMember ||
            (registration.Registration.IsRelatedToMember && availItem.AllowRelateProfileMemberPrice)) &&
          availItem.HasMemberPricing
        ) {
          availItem.ExtendedPrice = availItem.Quantity * availItem.MemberPrice;
          singleQuantityPrice = availItem.MemberPrice;
        } else {
          availItem.ExtendedPrice = availItem.Quantity * availItem.NonMemberPrice;
          singleQuantityPrice = availItem.NonMemberPrice;
        }
      } else {
        availItem.ExtendedPrice = 0;
      }

      eventItemTotal.ItemTotal = availItem.ExtendedPrice;

      //display price is the extended price before any promo codes are applied
      let fullPrice = availItem.ExtendedPrice;
      availItem.DisplayPrice = availItem.ExtendedPrice;

      let cummulativeDiscountAmount: number = 0;

      let promoCodes = registration.PromoCodes.filter(
        (x) =>
          x.EventItemIds.some((i) => availItem.Quantity > 0 && i == availItem.EventItemId) &&
          (!x.ApplyOncePerReg || usedOneTimePromoCodeIds.indexOf(x.PromoCodeId) < 0)
      );

      // don't use use-once promo-codes more than once per registration
      let eventItemPromoCodesUseOnce = promoCodes.filter((x) => x.ApplyOncePerReg);
      eventItemPromoCodesUseOnce.forEach((x) => usedOneTimePromoCodeIds.push(x.PromoCodeId));

      if (promoCodes) {
        for (let promoCode of promoCodes) {
          let discountAmount: number = 0;

          if (!promoCode.ApplyOncePerReg) {
            if (promoCode.DiscountType == PromoCodeDiscountType.Dollar) discountAmount = availItem.Quantity * promoCode.Discount;
            else if (promoCode.DiscountType == PromoCodeDiscountType.Percent) discountAmount = (fullPrice * promoCode.Discount) / 100;
          } else {
            if (promoCode.DiscountType == PromoCodeDiscountType.Dollar) discountAmount = Math.min(singleQuantityPrice, promoCode.Discount);
            else if (promoCode.DiscountType == PromoCodeDiscountType.Percent)
              discountAmount = Math.min(singleQuantityPrice, (singleQuantityPrice * promoCode.Discount) / 100);
          }

          if (discountAmount > availItem.ExtendedPrice) discountAmount = availItem.ExtendedPrice;

          // don't let the sum of discounts exceed the price
          if (cummulativeDiscountAmount + discountAmount > availItem.ExtendedPrice)
            discountAmount = availItem.ExtendedPrice - cummulativeDiscountAmount;

          cummulativeDiscountAmount += discountAmount;
        }
      }

      let benefitsToApply = registration.Registration.BenefitsToApply.filter(
        (x) => x.EventPriceId == availItem.EventItemId || x.EventPriceId == 0
      );
      if (benefitsToApply) {
        for (let benefit of benefitsToApply) {
          let extendedPriceRemaining = availItem.ExtendedPrice - cummulativeDiscountAmount;
          if (extendedPriceRemaining >= 0) cummulativeDiscountAmount += Math.min(extendedPriceRemaining, benefit.ValueToApply);
          else {
            // it's negative. only apply it if we peak above 0.
            let amountToAdd = Math.max(0, extendedPriceRemaining + benefit.ValueToApply);
            cummulativeDiscountAmount += amountToAdd;
            benefit.ValueToApply = amountToAdd;
          }
        }
      }

      if (cummulativeDiscountAmount > 0) {
        availItem.ExtendedPrice -= cummulativeDiscountAmount;
      }

      // just in case the price somehow dipped below 0
      if (availItem.ExtendedPrice < 0) {
        availItem.ExtendedPrice = 0;
      }

      if (availItem.DisplayPrice < 0) {
        availItem.DisplayPrice = 0;
      }

      if (availItem.Taxable && availItem.Quantity > 0) {
        //old
        //taxAmount = taxAmount + this._utilService.round(availItem.TaxFlatAmount, 2);
        //taxAmount = taxAmount + this._utilService.round(((availItem.TaxPercent * availItem.ExtendedPrice) * .01), 2);

        //new round on item by item basis to work the same as the back end
        for (let taxItem of availItem.TaxItems) {
          let currentTaxAmount = taxItem.FlatAmount + this._utilService.round(taxItem.Percent * availItem.ExtendedPrice * 0.01, 2);
          taxAmount = taxAmount + currentTaxAmount;
        }
      }

      itemTotal = itemTotal + availItem.ExtendedPrice;

      if (availItem.Quantity > 0) {
        discountTotal += cummulativeDiscountAmount;
        eventItemTotal.DiscountTotal = cummulativeDiscountAmount;
        eventItemTotals.push(eventItemTotal);
      }
    }

    // calculate custom registration response totals
    if (registration.Registration.EventCustomRegFieldResponses) {
      for (let response of registration.Registration.EventCustomRegFieldResponses.filter((r) => r && r.CustomField)) {
        if (
          response.CustomField.AvailableValues &&
          response.CustomField.AvailableValues.length &&
          response.EventCustomRegFieldAvailValuesId > 0
        ) {
          let amt: number = 0;
          let selectedValue = response.CustomField.AvailableValues.find((av) => av.Id == response.EventCustomRegFieldAvailValuesId);
          if (selectedValue && selectedValue.Amount > 0) {
            amt = selectedValue.Amount;

            // only apply to one event item's breakout
            let eventItemTotal = eventItemTotals.find((x) => response.CustomField.EventItemIds.indexOf(x.EventItem.EventItemId) > -1);

            if (eventItemTotal) {
              eventItemTotal.AdditionalCost += selectedValue.Amount;
              taxAmount += selectedValue.TaxAmount;
            }
          }

          itemTotal += amt;
        }
      }
    }

    // calculate attendee response totals
    if (registration.Attendees && registration.Attendees.some((a) => a.CustomFieldResponses.length > 0)) {
      for (let attende of registration.Attendees) {
        for (let response of attende.CustomFieldResponses) {
          if (
            response.CustomField.AvailableValues &&
            response.CustomField.AvailableValues.length &&
            response.EventCustomRegFieldAvailValuesId > 0
          ) {
            let amt: number = 0;
            let selectedValue = response.CustomField.AvailableValues.find((av) => av.Id == response.EventCustomRegFieldAvailValuesId);
            if (selectedValue && selectedValue.Amount > 0) {
              amt = selectedValue.Amount;

              let eventItemTotal = eventItemTotals.find((x) => response.CustomField.EventItemIds.indexOf(x.EventItem.EventItemId) > -1);

              if (eventItemTotal) {
                eventItemTotal.AdditionalCost += selectedValue.Amount;
                taxAmount += selectedValue.TaxAmount;
              }
            }

            itemTotal += amt;
          }
        }
      }
    }

    let fullPriceTotal = eventItemTotals
      .map((eventItemTotal) => eventItemTotal.ItemTotal + eventItemTotal.AdditionalCost)
      .reduce((sum, x) => sum + x, 0);

    eventItemTotals.forEach(
      (eventItemTotal) =>
        (eventItemTotal.Total = Math.max(0, eventItemTotal.ItemTotal + eventItemTotal.AdditionalCost - eventItemTotal.DiscountTotal))
    );

    //add fee for payment option if applies
    let paymentMethodFee = 0;
    if (registration.Registration.DoNotAddPaymentOptionFee) {
      registration.Registration.PaymentOptionFeeAmount = 0;
      registration.Registration.ExistingPaymentOptionFees = 0;
    } else {
      if (this._utilService.isNotNullOrUndefined(registration.Registration.SelectedPaymentMethod)) {
        var feeAmountToCalcFrom = fullPriceTotal - discountTotal;
        if (feeAmountToCalcFrom > 0) {
          //only apply the fee is the amount we calculate it off of is > 0
          if (registration.Registration.SelectedPaymentMethod.Fee > 0) {
            if (registration.Registration.SelectedPaymentMethod.FeeType == 1) {
              //%

              if (registration.Registration.ExistingPaymentOptionFees > 0) {
                feeAmountToCalcFrom = feeAmountToCalcFrom + registration.Registration.ExistingPaymentOptionFees;
              }

              paymentMethodFee = this._utilService.round(
                registration.Registration.SelectedPaymentMethod.Fee * 0.01 * feeAmountToCalcFrom,
                2
              );
            } else {
              //flat fee
              paymentMethodFee = registration.Registration.SelectedPaymentMethod.Fee;
            }
            //round to match backend
            paymentMethodFee = this._utilService.round(paymentMethodFee, 2);

            if (paymentMethodFee > 0) {
              for (let payTaxItem of registration.Registration.SelectedPaymentMethod.TaxItems) {
                //TODO add payment method fee taxes
                if (payTaxItem.FlatAmount > 0) {
                  taxAmount = taxAmount + payTaxItem.FlatAmount;
                } else {
                  taxAmount = taxAmount + this._utilService.round(payTaxItem.Percent * paymentMethodFee * 0.01, 2);
                }
              }
            }
          }
        }
      }

      if (registration.IsEdit) {
        if (
          registration.Registration.PaymentOptionFeeAmount <= 0 &&
          registration.Registration.ExistingPaymentOptionFeesSet == false &&
          paymentMethodFee > 0
        ) {
          //only set first time on edit and set the "new" PaymentOptionFeeAmount to 0
          registration.Registration.ExistingPaymentOptionFees = paymentMethodFee;
          registration.Registration.PaymentOptionFeeAmount = 0;
          registration.Registration.ExistingPaymentOptionFeesSet = true;
        } else {
          //this is a new fee
          registration.Registration.PaymentOptionFeeAmount = paymentMethodFee;
        }
      } else {
        //create always set
        registration.Registration.PaymentOptionFeeAmount = paymentMethodFee;
      }
    }

    registration.Registration.PreTaxPreDiscountAmount = fullPriceTotal;
    registration.Registration.PreTaxAmount = itemTotal;
    registration.Registration.TaxAmount = taxAmount;
    registration.Registration.TotalAmount =
      itemTotal + taxAmount + registration.Registration.PaymentOptionFeeAmount + registration.Registration.ExistingPaymentOptionFees;
    registration.Registration.DiscountTotal = discountTotal;
    registration.Registration.EventItemTotals = eventItemTotals;

    // apply benefits
    //registration.Registration.TotalAmount = registration.Registration.TotalAmount - registration.Registration.BenefitsToApplyTotal; // - registration.Registration.BenefitsPreviouslyAppliedTotal;
    //if (registration.Registration.TotalAmount < 0) {
    //    registration.Registration.TotalAmount = 0;
    //}

    registration.Registration.PaymentAmount = registration.Registration.TotalAmount;

    if (registration.IsEdit) {
      //set payment amount
      registration.Registration.AdditionalPaymentAmountForEdit =
        registration.Registration.TotalAmount - registration.Registration.AlreadyPaidAmountForEdit;

      // get the delta between the original invoice amount and the new invoice amount.
      registration.Registration.InvoiceTotalDelta =
        this._utilService.round(registration.Registration.OriginalInvoiceTotalAmount, 2) -
        this._utilService.round(registration.Registration.TotalAmount, 2);

      //if (registration.Registration.PaymentOption == 3 || registration.Registration.PaymentOption == 5) {

      //    registration.Registration.AdditionalPaymentAmountForEdit = registration.Registration.TotalAmount - registration.Registration.AlreadyPaidAmountForEdit;

      //} else {

      //    registration.Registration.AdditionalPaymentAmountForEdit = 0;
      //}

      if (registration.Registration.AdditionalPaymentAmountForEdit < 0) {
        //if the amount is less than 0 we need an unapplied payment  or refund card option selected
        //so check if they already have flagged refund cc and if not force CreateUnappliedPayments
        if (registration.ModificationOptions.RefundCreditCardPayments == false) {
          registration.ModificationOptions.CreateUnappliedPayments = true;
        }
      } else {
        //cannot do refund or create unapplied payments
        //unless the additional payment amount is less than 0 - we owe them money
        registration.ModificationOptions.CreateUnappliedPayments = false;
        registration.ModificationOptions.RefundCreditCardPayments = false;
      }
    } else {
      registration.Registration.AdditionalPaymentAmountForEdit = registration.Registration.PaymentAmount;
    }
  }

  public exportRegistrations = (eventId: number): Promise<string> => {
    //Event/{id:INT}/Registrations/csv
    let url = 'Event/' + eventId.toString() + '/Registrations/Export';
    return this._apiService.get(url);
  };

  public exportRegistrationsExtended = (eventId: number): Promise<string> => {
    //Event/{id:INT}/Registrations/csv
    let url = 'Event/' + eventId.toString() + '/Registrations/Export/Extended';
    return this._apiService.get(url);
  };

  public exportRegistrationsExtendedAsExcel(eventId: number): Promise<string> {
    return this._apiService.get(`Event/${eventId}/Registrations/Export/Extended/Excel`);
  }

  public exportRegistrationsExtendedAndFiltered = (eventId: number, registrationIds: Array<number>): Promise<string> => {
    //Event/{id:INT}/Registrations/csv
    let url = 'Event/' + eventId.toString() + '/Registrations/Export/Extended/Filtered';
    return this._apiService.post(url, registrationIds);
  };

  public printAllEventInvoices = (eventId: number): Promise<string> => {
    return this._userService.getCurrentUserLegacyToken().then((token: string) => {
      let url =
        this._navigationService.getLegacyDomain() +
        '/external/wcpages/v12/webclient/report/report.aspx?reportname=Revenue_InvoicesEventIDParam&Invoices=All%20Invoices&EventID=' +
        eventId.toString() +
        '&token=' +
        token;
      return url;
    });
  };

  public printOpenEventInvoices = (eventId: number): Promise<string> => {
    return this._userService.getCurrentUserLegacyToken().then((token: string) => {
      const url =
        this._navigationService.getLegacyDomain() +
        `/external/wcpages/v12/webclient/report/report.aspx?reportname=Revenue_InvoicesWhereClauseParam&OpenInvoiceEventId=${eventId}&token=${token}`;
      return url;
    });
  };

  public getInvoiceReport(invoiceNum: number): Promise<string> {
    return this._userService.getCurrentUserLegacyToken().then((token: string) => {
      let url =
        this._navigationService.getLegacyDomain() +
        '/external/wcpages/v12/webclient/report/report.aspx?reportname=Revenue_InvoicesInvoiceNumParam&InvoiceNum=' +
        invoiceNum.toString() +
        '&token=' +
        token;

      return url;
    });
  }

  public sendConfirmationEmail = (registrationIds: Array<number>): Promise<void> => {
    let url = 'Event/Registrations/SendConfirmationEmail';
    return this._apiService.post(url, registrationIds);
  };

  public emailRegistrations = (registrationHeaderIds: Array<number>): Promise<string> => {
    return this._userService.getCurrentUserLegacyToken().then((data: string) => {
      this._userLegacyToken = data;

      return this._apiService
        .post('EventRegistrations/QueueEmailsForWebClientSendEmail', registrationHeaderIds)
        .then((queueKey: string) => {
          if (!queueKey) return '';

          let url2 =
            this._navigationService.getLegacyDomain() +
            '/External/WCPages/v12/WebClient/Email/Send.aspx?token=' +
            this._userLegacyToken +
            '&QueueKey=' +
            encodeURIComponent(queueKey);
          return url2;
        });
    });
  };

  public emailAttendees = (attendeeHeaderIds: Array<number>): Promise<string> => {
    return this._userService.getCurrentUserLegacyToken().then((data: string) => {
      this._userLegacyToken = data;

      return this._apiService.post('EventAttendees/QueueEmailsForWebClientSendEmail', attendeeHeaderIds).then((queueKey: string) => {
        if (!queueKey) return '';

        let url2 =
          this._navigationService.getLegacyDomain() +
          '/External/WCPages/v12/WebClient/Email/Send.aspx?token=' +
          this._userLegacyToken +
          '&QueueKey=' +
          encodeURIComponent(queueKey);
        return url2;
      });
    });
  };

  public applyManualPayments = (invoicePayments: Array<InvoicePayment>): Promise<void> => {
    let url: string = '/Revenue/ApplyManualPayments';
    return this._apiService.post(url, invoicePayments);
  };

  /**
   * get registration confirmation message for registration registrationId
   * @param registrationId
   */
  public getRegistrationConfirmationMessage(registrationId: number): Promise<string> {
    return this._apiService.get(`/Event/Registration/${registrationId}/ConfirmationMessage`);
  }
}
